import { Cookies } from 'react-cookie-consent';
import { addSeconds, getTime, formatDistance } from 'date-fns';
import { sl } from 'date-fns/locale';

export const isRestricted = (useRateLimiting, url) => {
	const shouldRestrict = parseInt(useRateLimiting) > 0 ? true : false;
	if (shouldRestrict) {
		return Cookies.get(url) ? true : false;
	} else {
		removeRestriction(url);
		return false;
	}
};

export const whenRestrictionExpires = (url) => {
	const cookieValue = Cookies.get(url);
	if (cookieValue) {
		return formatDistance(parseInt(cookieValue), Date.now(), {
			locale: sl,
			addSuffix: true,
		});
	}
	return null;
};

export const createRestriction = (seconds, url) => {
	if (seconds === 0) return;
	const COOKIE_VALUE = getTime(addSeconds(Date.now(), seconds));
	const EXPIRE = new Date(COOKIE_VALUE);
	Cookies.set(url, COOKIE_VALUE, { expires: EXPIRE });
};

export const removeRestriction = (url) => Cookies.remove(url);
